import { render, staticRenderFns } from "./SalesOrderReturn.vue?vue&type=template&id=ba666584&scoped=true"
import script from "./SalesOrderReturn.vue?vue&type=script&lang=ts"
export * from "./SalesOrderReturn.vue?vue&type=script&lang=ts"
import style0 from "./SalesOrderReturn.vue?vue&type=style&index=0&id=ba666584&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba666584",
  null
  
)

export default component.exports